module.exports = __webpack_public_path__ + "img/duration.9414f56e.svg";